document.querySelectorAll('[data-editorial-form]').forEach((form) => {
    if (form.dataset.initialized) {
        return;
    }

    form.dataset.initialized = 'true';

    form.addEventListener('submit', (event) => {
        const category = form.querySelector('[data-editorial-category]');
        const format = form.querySelector('[data-editorial-format]');
        const option = category?.selectedOptions[0];
        const destination = option?.dataset.url;

        if (!destination) {
            return;
        }

        event.preventDefault();

        const url = new URL(destination, window.location.origin);
        const formatKey = category.value ? 'editorial-1-format' : format?.name;

        if (format?.value && formatKey) {
            url.searchParams.set(formatKey, format.value);
        }

        window.location.assign(url.href);
    });
});
